<template>
  <div class="flex flex-row gap-1">
    <div
      v-if="technologies && technologies.length > 0"
      class="mt-1.5 text-xs text-gray-500 dark:text-gray-400 hover:text-blue-500 dark:hover:text-blue-400 cursor-pointer flex items-center gap-1 group/expand transition-all"
    >
      <ChevronRightIcon
        class="size-3.5 transition-transform group-hover/expand:text-blue-500 dark:group-hover/expand:text-blue-400"
      />
      <span> </span>
    </div>

    <div class="flex flex-column">
      <div class="flex flex-column items-center gap-2">
        <div class="flex items-center gap-4">
          <div v-if="showAvatar" class="shrink-0">
            <div class="relative">
              <span
                class="inline-flex items-center justify-center size-12 rounded-full bg-blue-50 text-base font-semibold text-blue-600 ring-2 ring-white dark:ring-gray-800"
              >
                {{
                  item ? getIniciales(item.copnNombre1, item.copnApellido1) : ''
                }}
              </span>
              <span
                class="absolute -bottom-0.5 -right-0.5 rounded-full border-2 border-white dark:border-gray-800 size-3"
                :class="
                  item?.coprTipoEstado === 'ACTIVO'
                    ? 'bg-emerald-400'
                    : 'bg-red-400'
                "
              >
              </span>
            </div>
          </div>
          <div class="flex-1 min-w-0 group">
            <div class="space-y-1">
              <p
                class="text-sm font-medium text-gray-900 truncate dark:text-white group-hover:text-blue-600 transition-colors"
              >
                {{ item?.copnNombre1 }} {{ item?.copnApellido1 }}
              </p>
              <div class="flex items-center gap-2">
                <span
                  v-if="item?.tipoidentificacion"
                  class="inline-flex items-center rounded-md bg-blue-50 px-2 py-0.5 text-xs font-medium text-blue-700 ring-1 ring-inset ring-blue-700/10 dark:bg-blue-400/10 dark:text-blue-400"
                >
                  {{ item?.tipoidentificacion?.comaNombrecorto }}
                  {{ item?.copeIdentificacion }}
                </span>
                <span
                  v-if="item?.cargo"
                  class="inline-flex items-center rounded-md px-2 py-0.5 text-xs font-bold bg-gray-50 text-gray-700 ring-1 ring-inset ring-gray-700/10 dark:bg-gray-400/10 dark:text-gray-400"
                >
                  {{ item.cargo.comaNombrelargo }}
                </span>
              </div>
              <span
                v-if="fecha"
                class="text-xs text-gray-500 dark:text-gray-400 flex items-center gap-2"
              >
                <span>
                  {{
                    fecha.toLocaleString('es-Co', opcionesDate).toUpperCase()
                  }}
                </span>
                <span
                  v-if="getFirstTechnology()?.cittHora"
                  class="inline-flex items-center px-2 py-0.5 rounded-sm text-xs font-medium text-gray-700 bg-gray-100 dark:bg-neutral-800 dark:text-neutral-300"
                >
                  {{ getFirstTechnology()?.cittHora }}
                </span>
                <span class="flex items-center gap-2">
                  <span class="sr-only">Turno</span>
                  <template
                    v-if="
                      getFirstTechnology()?.cittTipoTurno !== undefined &&
                      getFirstTechnology()?.cittTipoTurno !== null
                    "
                  >
                    <span
                      class="inline-flex items-center px-2 py-0.5 rounded-sm text-xs font-medium text-gray-700 bg-gray-100 dark:bg-neutral-800 dark:text-neutral-300"
                    >
                      Turno {{ getFirstTechnology()?.cittTipoTurno }}
                    </span>
                  </template>
                </span>
              </span>
            </div>
          </div>
        </div>

        <div v-if="!item" class="flex items-center gap-2 group">
          <div class="shrink-0">
            <span
              class="inline-flex items-center justify-center size-7 rounded-full bg-gray-100 text-gray-400 group-hover:bg-gray-200 transition-colors dark:bg-gray-800 dark:text-gray-500"
            >
              <UserIcon class="size-4" />
            </span>
          </div>
          <p
            class="text-sm text-gray-400 dark:text-gray-500 group-hover:text-gray-600 dark:group-hover:text-gray-400 transition-colors"
          >
            Sin asignación
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ChevronRightIcon, UserIcon } from '@heroicons/vue/24/outline'
import { getIniciales } from '@/modules/Core/usings/generales'
import type { IConfPersonasEmpleado } from '@/modules/Administracion/interfaces'
import type { ICitaTechnologiasSalud } from '@/modules/Asistencial/interfaces'

const props = defineProps<{
  item?: IConfPersonasEmpleado
  showAvatar?: boolean
  technologies?: ICitaTechnologiasSalud[]
  fecha?: Date
}>()

const getFirstTechnology = () => {
  if (!props.technologies || props.technologies.length === 0) return null
  return props.technologies[0]
}
const opcionesDate = {
  year: 'numeric' as const,
  month: '2-digit' as const,
  day: '2-digit' as const,
  hour12: true
}
</script>
